import { useCart } from "../../app/context/cart-context/cart-context";
import { Suspense, useEffect, useState } from "react";
import ApiServices from "../../service/ApiServices";
import { motion } from "framer-motion";

import { Spinner } from "../template/spinner/spinner";
import { ProductCard } from "../template/product-card/product-card";
import { OrderButton } from "../template/buttons/order-button/order-button";
import { QuantitySelector } from "../template/inputs/quantity-selector/quantity-selector";

const res = new ApiServices();

export const Cart = () => {

    const { cart, setTotal } = useCart();
    const [products, setProducts] = useState([]);

    useEffect(() => {
        res.getCart(cart).then(data => setProducts(data))
    }, [cart]);

    let total = 0;

    const result = Object.values(products)
        .filter(item => cart.some(cartItem => cartItem.id === item.id))
        .map(product => {
            
            total += product.price * product.qty;
            setTotal(total);

            return (
                <ProductCard key={product.id} props={product}>
                    <div className="row d-flex justify-content-start aling-items-center">
                        <div className="col-6"><div className="col-12 product-price"><span>{product.price} грн</span></div></div>
                        <div className="col-6"> <QuantitySelector productId={product.id}/></div>
                    </div>
                </ProductCard>
            )
    });

    return (
        <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.5 } }}
        exit={{ opacity: 0 }}
        >
           <div className="container-fluid">
                {cart.length === 0 ?
                        <div className="h4 mt-3 text-center">Кошик пустий</div>
                    :
                        <OrderButton/>
                }
                <Suspense fallback={<Spinner/>}>
                       {result}
                </Suspense>
           </div>
        </motion.div>
    )
    
}
